import {
    ADDCHARGEMASTER_SUCCESS,
    ADDCHARGEMASTER_FAILED,
    RESET_ADDCHARGEMASTER,
    LOADING_ADDCHARGEMASTER,
    NETWORK_ERROR_ADDCHARGEMASTER
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetAddChargeMaster = () => {
    return { type: RESET_ADDCHARGEMASTER };
};

const addChargeMaster = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADDCHARGEMASTER });
    await partnerServices
        .post("addNewChargeMaster", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(addChargeMastersuccess(res.data));
                    break;
                default:
                    dispatch(addChargeMasterFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_ADDCHARGEMASTER,
                payload: err
            });
        });
};
function addChargeMastersuccess(data) {
    return {
        type: ADDCHARGEMASTER_SUCCESS,
        payload: data
    };
}
function addChargeMasterFailed(data) {
    return {
        type: ADDCHARGEMASTER_FAILED,
        payload: data
    };
}

export { resetAddChargeMaster, addChargeMaster };
